<script>
export default {
  name: 'AbstractDialogIndex',
  abstract: true,
  render () {
    const node = this.$slots.default ? this.$slots.default[0] : {};
    if (node.componentOptions) {
      let propsData = node.componentOptions.propsData || {};
      let data = node.data.attrs || {};
      const bindParams = data.bindParams || {};
      if (bindParams) {
        Object.keys(bindParams).map(v => {
          propsData[v] = bindParams[v];
        })
      }
      node.componentOptions.propsData = propsData
    }
    return node;
  }
}
</script>
